// extracted by mini-css-extract-plugin
module.exports = {"body":"Spin_body__tHhoH","container":"Spin_container__KPO11","overflow":"Spin_overflow__Py_ok"};